import React from "react";
import { Box } from "@mui/material";
import { findHcpMentionRanges } from "../../../../utils/hcpMentions";

const mentionChipSx = {
  display: "inline",
  color: "inherit",
  fontWeight: 700,
  backgroundColor: "rgba(255, 255, 255, 0.22)",
  borderRadius: "8px",
  px: "6px",
  py: "1px",
  mx: "1px",
};

export const renderHcpMentionText = (
  text: string,
  labels: string[],
): React.ReactNode => {
  const ranges = findHcpMentionRanges(text, labels);
  const nodes: React.ReactNode[] = [];
  let lastIndex = 0;
  let key = 0;

  for (const range of ranges) {
    if (range.start > lastIndex) {
      nodes.push(
        <React.Fragment key={`t-${key++}`}>
          {text.slice(lastIndex, range.start)}
        </React.Fragment>,
      );
    }
    nodes.push(
      <Box component="span" key={`m-${key++}`} sx={mentionChipSx}>
        {text.slice(range.start, range.end)}
      </Box>,
    );
    lastIndex = range.end;
  }

  if (lastIndex < text.length) {
    nodes.push(
      <React.Fragment key={`t-${key++}`}>{text.slice(lastIndex)}</React.Fragment>,
    );
  }

  return nodes;
};
